import { render } from "./Tabs.vue?vue&type=template&id=1af873cb&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=1af873cb&scoped=true&lang=css"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af873cb"]])

export default __exports__